module.exports = __webpack_public_path__ + "static/media/TECHM_F1.6df8a93b.txt";